<template>
  <div :style="`height:${vh}px ; overflow-y: scroll; -webkit-overflow-scrolling: touch;background:#000`">
    <div style="height: 30px; color: rgb(255, 255, 255); box-sizing: border-box; padding-left: 20px; display: flex; align-items: center" @click="$router.push({ path: '/' })">{{$t('header.home')}}</div>
    <iframe style="height: calc(100% - 30px); width: 100%" ref="iframe" scrolling="auto" frameborder="0" id="iframe"></iframe>
  </div>
</template>
<script>
export default {
  name: 'gamePage',
  data() {
    return {
      url: null,
      type: null,
      vh: 0,
      ios: false,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    // 打开代理
    console.log(query);
    if (query.dailiD == 1) {
      that.getAgentLoginUrl();
      return;
    }
    // 打开客服
    if (query.dailiD == 2) {
      that.getservicerurl();
      return;
    }
    if (query.app == 1) {
      that.$parent.showLoading();
      that.type = 'app';
      that.$parent.hideLoading();
      window.open(that.$store.state.appInfo.ios_download_url, '_self');
      return;
    }
    if (query.name) {
      that.goGamePage(query.name, query.type, query.code);
    }
  },
  methods: {
    // 打开客服
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    // 打开代理
    getAgentLoginUrl() {
      let that = this;
      that.$apiFun.get('/api/getAgentLoginUrl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    // 打开游戏
    goGamePage(name, type, code) {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/getGameUrl', { plat_name: name, game_type: type || 0, game_code: code, is_mobile_url: 1 })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
            that.$router.push({ path: '/' });
          }
          if (res.code == 200) {
            that.url = res.data.url;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          let that = this;
          that.$parent.hideLoading();
          that.$router.push({ path: '/' });
        });
    },
    goBack() {
      let that = this;
      console.log('goBack');
      that.$router.push({ path: '/' });

      return;
    },
  },
  mounted() {
    let that = this;
    that.vh = window.innerHeight; //* 0.01

    // // We listen to the resize event
    window.addEventListener('resize', () => {
      that.vh = window.innerHeight; //* 0.01
    });

    // 支持History API
    if (window.history && window.history.pushState) {
      // 向历史记录中插入了当前页
      console.log('pushState');
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goBack, false);
    } else {
      // 监听hash变化，点击浏览器向前向后切换
      window.addEventListener('hashchange', function () {
        var str = location.hash.substring(1);
        that.goBack();
      });
    }
  },
  updated() {
    let that = this;
  },
  destroyed() {
    //离开这个界面之后，删除事件
    window.removeEventListener('popstate', this.goBack, false);
    window.removeEventListener('resize', window, false);
    window.removeEventListener('hashchange', window, false);
  },
  watch: {
    url: {
      handler(newName, oldName) {
        let that = this;
        if (newName) {
          that.$nextTick(() => {
            that.$refs.iframe.contentWindow.location.replace(newName);
          });
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
// @import '../../../static/css/chunk-099d4415.690b75b1.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/gamePage.vue